import { createEffect, createStore } from 'effector';
import { createFetching } from '@lib/effector-utils';

import { fetchWorkforceSummary } from '../api';

const HR_DEPARTMENT_ID = 1;

export const fetchWorkforceEffect = createEffect('fetch workforce summary');
fetchWorkforceEffect.use(fetchWorkforceSummary);

export const $workforceFetching = createFetching(fetchWorkforceEffect);

export const $workforceSummary = createStore(null).on(
  fetchWorkforceEffect.done,
  (_, { result }) => (result && result.data) || null,
);

/**
 * Whether to offer the Saudization index in the navigation. The backend grants
 * it to the HR team and to holders of users.view_workforce_summary, which
 * whoami does not expose; directors (CEO, Managing Director) are offered it
 * too and see the page's no-access state until they hold that permission.
 */
export function canSeeWorkforceSummary(_, user) {
  if (!user) return false;
  const isHrTeam = Boolean(
    user.department && user.department.id === HR_DEPARTMENT_ID,
  );
  return isHrTeam || user.position === 'director';
}
